<div class="control">
    <fui-deprecated-text-control class="control-field" (focussed$)="onFocus()" [isLoading]="isLoading"
                                 [(ngModel)]="value"
                                 [placeholder]="placeholder" [type]="type">
        <fui-icon class="object" [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
    </fui-deprecated-text-control>
    @if (isToggled()) {
        <div class="control-overlay" (click)="leave()"></div>
    }
    @if (isToggled()) {
        <div class="control-modal">
            <div class="control-modal-window">
                <div class="control-modal-window-content">
                    <fui-deprecated-autocomplete-control-results [increment]="20" [limit]="20" [results]="results"
                                                                 [show]="showMore">
                        <ng-template #autocompletecontrolresult let-result="result">
                            <ng-container [ngTemplateOutlet]="autocompleteControlResults"
                                          [ngTemplateOutletContext]="$any({result: result})"></ng-container>
                        </ng-template>
                    </fui-deprecated-autocomplete-control-results>
                </div>
            </div>
        </div>
    }
</div>
